"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rosterPersonaFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
const Mocks = require("../../../mocks");
exports.rosterPersonaFactory = Factory.Sync.makeFactory({
    _links: [],
    created_at: Mocks.dates.date2000,
    extended_attributes: [],
    headshot: null,
    id: Factory.each(i => uuid_1.v4()),
    invitation: { status: 'sent', last_sent_at: Mocks.dates.date2000 },
    jersey_number: '12',
    name: 'Jon Doe',
    originator_id: '4567',
    originator_system: 'Ngin',
    originator_type: 'roster_player',
    originator_updated_at: Mocks.dates.date2000,
    participation_status: 'active',
    persona: { persona_id: '123', _links: [] },
    positions: [],
    roster_id: Factory.each(i => uuid_1.v4()),
    roster_role: 'player',
    roster_status: 'approved',
    updated_at: Mocks.dates.date2000,
});
